<template>
  <div>
    <v-card class="mx-auto my-5" max-width="800" outlined>
      <v-card-title>
        <span class="headline">فروش سال جاری</span>
      </v-card-title>
      <v-card-subtitle>نمودار فروش ماه های سال جاری</v-card-subtitle>
      <v-card-text>
        <div v-if="chartData" class="chart-container">
          <line-chart :chart-data="chartData" :key="'hi'" />
        </div>
        <div v-else class="text-center">در حال بارگذاری...</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

export default {
  components: {
    LineChart: {
      extends: Bar,
      props: ["chartData"],
      mounted() {
        this.renderChart(this.chartData, { responsive: true, maintainAspectRatio: false });
      },
    },
  },
  data() {
    return {
      url: "sobhanAdmin/monthly-sales-stats/",
      chartData: null,
    };
  },
  methods: {
    fetchData() {
      this.request({
        url: this.endpoint(this.url),
        params: {
          days: this.selectedDays,
        },
        success: (data) => {
          const labels = data.map((item) => item.date);
          const dataset = data.map((item) => (item.count / 10_000_000).toFixed(2));

          this.chartData = {
            labels: labels,
            datasets: [
              {
                label: "فروش سال جاری (میلیون تومان)",
                data: dataset,
                backgroundColor: "rgba(54, 162, 235, 0.2)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
                pointBackgroundColor: "rgba(54, 162, 235, 1)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(54, 162, 235, 1)",
                fill: true,
              },
            ],
          };
        },
        error: (err) => {
          console.error("Error fetching chart data:", err);
        },
      });
    },
  },
  mounted() {
    this.fetchData(); // Fetch data on mount
  },
};
</script>

<style scoped>
.chart-container {
  height: 400px;
  position: relative;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #777;
}
</style>
